import { POST } from '@/utils/request'
import Api from './url'

// 处理进度分页查询入参
export interface IPagingProcessingProgressParams {
  status: number // 状态 Tab：0全部、1处理中、2已完成
  pageNo: number // 页码，从1开始
  pageSize: number // 每页条数
}

// 外呼明细
export interface IOutboundCallDetail {
  id: number | null
  callIdentity: number | null // 客户身份：1寄件人、2收件人、3下单人
  callIdentityDesc: string | null
  callState: number | null // -1待呼叫、-2呼叫中、-3呼叫失败、0未接通、4已接通
  callStateDesc: string | null
  callTime: number | null
  resultValue: string | null
}

// 装备售后进度（type=1）
export interface IEquipmentProgress {
  aftersaleType: number | null
  aftersaleTypeDesc: string | null
  orderNo: string | null
  equipmentName: string | null
  processStatus: number | null
  processStatusDesc: string | null
  showType: number | null
  showTypeDesc: string | null
}

// 无法联系寄收件人进度（type=2）
export interface IOutboundProgress {
  orderNumber: string | null
  taskStatus: number | null
  taskStatusDesc: string | null
  callState: number | null
  callStateDesc: string | null
  callObjectDesc: string | null
  callStartTime: number | null
  resultCode: string | null
  callDetails: IOutboundCallDetail[] | null
}

// 身份权益恢复进度（type=3）
export interface IRightsRecoveryProgress {
  rightsType: number | null
  rightsTypeDesc: string | null
  applyType: number | null
  applyTypeDesc: string | null
  restStartTime: number | null
  restEndTime: number | null
  auditStatus: number | null
  auditStatusDesc: string | null
}

// 上门费补贴进度（type=4）
export interface IDoorFeeProgress {
  orderNumber: string | null
  auditStatus: number | null
  auditStatusDesc: string | null
}

// 处理进度记录
export interface IProcessingProgressItem {
  type: number // 业务类型：1装备售后、2无法联系寄收件人、3身份权益恢复、4上门费补贴
  typeDesc: string
  recordId: number
  ticketId: number
  ticketNumber: string | null
  problemName: string | null
  status: number // 页面处理状态：1处理中、2已完成
  statusDesc: string
  ticketStatus: number
  ticketStatusDesc: string | null
  ctime: number | null
  processTime: number | null
  equipment: IEquipmentProgress | null
  outbound: IOutboundProgress | null
  rightsRecovery: IRightsRecoveryProgress | null
  doorFee: IDoorFeeProgress | null
}

export const pagingProcessingProgress = async (data: IPagingProcessingProgressParams) => {
  return await POST({ url: Api.pagingProcessingProgress, data, showError: false })
}
